<template>
	<div class="col-md-7 col-lg-8 wrapper-rounded-content content-mybookings">
		<div class="bg-blue-multiply rounded-corners"></div>

		<div class="row justify-content-center headinline">
			<div class="col-md-12">
				<h1 class="d-inline-block">{{ $t('Zahlungsart') }}</h1>
						
						<div class="row" style="margin-top: 1.5rem;">
								
									<div class="col col-md-12" v-if="changeData">
										<div class="col col-md-12">
											<div  id="inline-widget-container" style="height: 400px;">

											</div>
										</div>
										<div class="col col-md-12">
											<button class="btn btn-primary btn-wp float-right"  @click.prevent="validate()"><span class="btn-text">Bezahlmethode hinzufügen</span></button>
										</div>
									</div>
									
									<div v-else>
										<p>Bestätigte Methode: {{customer_data.payment_type}}</p>
										<button class="btn btn-outline-info btn-wp" @click.prevent="changeConcardis">Zahlungsmethode ändern</button>
									</div>
								
						</div>
						
					
			</div>
		</div>
	</div>
</template>

<script>
	/**
	 *  {{ $t("GLOBAL.GLOBAL.ORDER_STATUS_ABGERECHNET") }}
		{{ $t("GLOBAL.GLOBAL.ORDER_STATUS_ABGESCHLOSSEN") }}
		{{ $t("GLOBAL.GLOBAL.ORDER_STATUS_IN_RENT") }}
		{{ $t("GLOBAL.GLOBAL.ORDER_STATUS_RESERVIERUNG") }}
		{{ $t("GLOBAL.GLOBAL.ORDER_STATUS_STORNIERT") }}
	 */
import formatter from '@/store/orm/helpers/formater';
import { mapGetters } from 'vuex';

export default {
	name: 'PageMyPayment',
	computed: {

		...mapGetters('orm/reservation', {
	    	user_session: 'user_session'
	    }),

	    ...mapGetters('orm', {
	    	resGroups: 'groups',
			resGroup: 'group',
			resStation: 'station',
	    }),
	},
	data() {
		return {
			formatter,
			customer_data: {},
			oldpayment_id: '',
			oldpayment_type: '',
			merchant_id: 'merchant_bwgbauulaj',
			changeData : false,
			optionalParameters: {
				"language": "de",
				"layout": "dropdown",
				"customStyleId": "customstyle_9pyy7pcwki",
				"hidePayButton": true,
				"hideTitleIcons": true,
				"skipFinalResultView": true,
				"paymentDetails": {
					"paypal": {
					"returnUrl": "http://return.url",
					"cancelUrl": "http://cancel.url"
					}
				},
				"optionalFields": {
					"creditCard": null,
					"sepa": {
						"bic": true,
						"bankName": false,
						"requestMandate": true,
						"directDebitType": "FIRST"
					},
					"paypal": null
				}
			},
		};
	},

	beforeMount(){
		let payengine = document.createElement('script');
		payengine.setAttribute('src', 'https://pptest.payengine.de/bridge/1.0/payengine.min.js');
		payengine.async = true;
		document.head.appendChild(payengine);

		let payengine_widget = document.createElement('script');
		payengine_widget.setAttribute('src', 'https://pptest.payengine.de/widgetjs/payengine.widget.min.js');
		payengine_widget.async = true;
		document.head.appendChild(payengine_widget);
	},
	
	mounted() {
		var self = this;
		
		this.$emit("isActive", "payment");

		this.$store.dispatch('orm/GET_CUSTOMER')
		.then(result => {
			console.log('GET_CUSTOMER', result)
			self.customer_data = result

			self.optionalParameters.initCallback = this.initCallback;
			self.optionalParameters.cofAgreementStateCallback = this.cofAgreementStateCallback;
			
			if(!this.customer_data.payment_customer){
				this.initConcardis();
			}

		}).catch(err => { this.$store.commit("core/ADD_ERROR", err); });


		
		

/* 		this.$store.dispatch('orm/GET_CUSTOMER_RESERVATION')
		.then(result => {
			self.reservations = result.result;
			console.log(result.result);

		}).catch(err => { this.$store.commit("core/ADD_ERROR", err); }) */
	},
	methods: {
		changeConcardis(){
			var self = this;
			this.changeData = true;
			self.initConcardis();
		},
		initConcardis(){
			var self = this;
			setTimeout(() => {
						PayEngine.setPublishableKey( self.merchant_id );
						PayEngineWidget.initAsInlineComponentPi(
							'inline-widget-container',
							self.merchant_id,
							self.optionalParameters,
							self.resultCallback
							);
			}, 750);
		},
		resultCallback(error, paymentInstrument) {

			var threeDsVersionResult = null;
			var self = this;


			function onThreeDsAuthenticationResult(error, threeDsAuthenticationResult) {
				if (self.cofType === 'ONECLICK') {
				if (cofAgreementState && cofAgreementState.checked) {
					// You need to create a cof contract with the upcoming order
				} else {
					// Store payment details is not checked
				}
				} else {
				if (self.cofType === 'SCHEDULED' || self.cofType === 'UNSCHEDULED') {
					window.PayEngine.cardCheck(paymentInstrument.paymentInstrumentId, self.cofType, null, function() {
					//Optionally you can call https://apitest.payengine.de/v1/payment-instruments/{paymentInstrument.paymentInstrumentId}
					//in order to get the final version of the payment instrument, including the newly created COF contract
					});
				}
				}
			}
			
			function browserInfoCallback(error, result) {
				if (error) {
				//browserInfo call failed
				return;
				}
				var parameters = {
				browserInfoId: result.browserInfoId,
				type: 'ADD_CARD',
				async: {
					notificationUrl: 'http://notification.example',
					successUrl: 'http://success.example',
					failureUrl: 'http://failure.example'
				}
				};
				window.PayEngine.threeDsAuthenticationRequest(paymentInstrument.paymentInstrumentId, threeDsVersionResult.id, parameters, onThreeDsAuthenticationResult);
			}

			function invokeMethodUrlCallback() {
				window.PayEngine.getBrowserInfo(browserInfoCallback);
			}

			function onThreeDsVersionCallback(error, result) {
				threeDsVersionResult = result;
				if (result.version === '2.0') {
				if (result.specificData && result.specificData.methodUrl) {
					window.PayEngine.invokeMethodUrl(result.specificData.methodUrl, result.specificData.base64EncodedThreeDsMethodData, 'inline-widget-container', invokeMethodUrlCallback);
				} else {
					invokeMethodUrlCallback();
				}
				} else {
				//3DS version is not 2
				}
			}

			if (error) {
				//Something went wrong with the creation of a payment instrument
			} else {
				window.PayEngine.threeDsVersion(paymentInstrument.paymentInstrumentId, onThreeDsVersionCallback);
			}

			
			console.log('Error/Result:', error, paymentInstrument);

			if(paymentInstrument.paymentInstrumentId){

				this.oldpayment_type = this.customer_data.payment_type;
				this.oldpayment_id = this.customer_data.payment_id;

				this.customer_data.payment_type = paymentInstrument.type;
				this.customer_data.payment_id = paymentInstrument.paymentInstrumentId;
				this.changePayment();
			}
		},

		validationListenerCallback(data) {
		console.log('Validation listener callback', data);
		},

		addValidationListener() {
		PayEngineWidget.addValidationListener(this.widgetRef, validationListenerCallback);
		},

		removeValidationListener() {
		PayEngineWidget.removeValidationListener(this.widgetRef, validationListenerCallback);
		},

		pay(step) {
			//this.paymentCheck.payment.required = true;

			PayEngineWidget.pay(this.widgetRef);

			
		},

		validate() {
		var self = this;
		function onValidationCallback(error, result) {
			console.log('Validate', error, result);
			if(result == true){
				self.pay();
			}else{
				//self.checkPayment('step2', true);
			}
			//bridgeValidateResult(error ? error : result);
		}

			PayEngineWidget.validate(this.widgetRef, onValidationCallback);

		
		},

		initCallback(error, iframeName) {
		console.log("Init callback", error, iframeName);
		this.widgetRef = iframeName;
		},

		changePayment(){

			var self = this;

			this.$store.dispatch('orm/CREATE_CONCARDIS_CUSTOMER', {
					email: self.customer_data.email
				}).then(res => { 
				self.customer_data.payment_customer = res.customerId;

				console.log(res);
				console.log(self.customer_data.payment_customer);
				self.$store.dispatch('orm/POST_CUSTOMER_PAYMENTINSTRUMENT', {
					payment_customer: self.customer_data.payment_customer,
					payment_id: self.customer_data.payment_id,
					}).then(res => { 
						self.$store.dispatch('orm/CHANGE_CUSTOMER_DATA', self.customer_data)
						.then(result => {
							//self.isModalVisible = true;
							console.log('RESULT', result);
							if(self.oldpayment_id){
								self.$store.dispatch('orm/DELETE_PAYMENTINSTRUMENT', {
								payment_customer: self.customer_data.payment_customer,
								payment_id: self.oldpayment_id,
								}).then(res => { 
									
								}).catch(err => { 
							
										self.$store.commit("core/ADD_ERROR", err); 
							
									});
							}
							self.changeData = false;

						})
						.catch(err => { this.$store.commit("core/ADD_ERROR", err); });
					}).catch(err => {this.$store.commit("core/ADD_ERROR", err);})
				}).catch(err => { this.$store.commit("core/ADD_ERROR", err); });

		},

		cofAgreementStateCallback(error, result) {
		console.log("cofAgreementStateCallback", error, result);

		//You need to assign the coAgreementState for future usage
		this.cofAgreementState = result;
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/PageMyPayment.vue